import gql from 'graphql-tag';

export default gql`
  fragment callActionFragment on CallAction {
    id
  }
`;
